import logo from './logo.svg';
import './App.css';
import * as routeLink from "./constants/routeLink";
import { BrowserRouter as Router, Routes, Route, Navigate, Redirect } from "react-router-dom";
import routers from "./routers";

import BottomTabs from "./components/BottomTabs/index";
import Header from "./components/Header/index";
import Footer from "./components/Footer/index";

import Splash from "./components/Splash/index";
import { useEffect, useState } from 'react';
import { addRef, getUser, Login, getInfoBet, history } from './services/services';
import { setUser,infoBet } from './actions/apiIndex';
import { useDispatch, useSelector } from 'react-redux';

import { ToastContainer, toast } from 'react-toastify';
import ModalDailog from './components/ModalDailog';
function App() {

  
  return (
    
    <Router>
     
      <ToastContainer />

   
        <div id="__next">
        <div id="basePage" className="base-page pt-[108px] h-screen overflow-y-auto __className_c5ed35">
        <div className="top-0 left-0 z-0 fixed w-screen h-screen pointer-events-none">
          <img alt="background" loading="lazy" decoding="async" data-nimg="fill" className="object-top object-cover"
            style={{position:"absolute",height:"100%",width:"100%",left:0,top:0,right:0,bottom:0,color:"transparent"}}
            sizes="100vw" src={`${routeLink.domain}/assets/imgs/bg-4k.png`}  />
        </div>
            <Header />
            {/* <div className="space-75"></div> */}
            <main className="relative pb-24 min-h-[calc(100vh_-_256px)]">
            <Routes>
              {routers.length > 0 &&
                routers.map((route, index) => {
                  // console.log(route);
                  return <Route
                    key={index}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    element={route.main({ routers: route.routers })}
                  />
                })}

              <Route path="/" exact element={<Navigate replace to={routeLink.HOME} />} />
            </Routes>
           
            </main>
          </div>
          <Footer />
          </div>
      
      
    </Router>
  );
}

export default App;
